import Text from "@ingka/text";
import { ComponentProps } from "react";
import Select from "react-select";
import { Option } from "./types";
import { INDICATOR_STYLE } from "./constants";
import ErrorLabel from "../ErrorLabel/ErrorLabel";

type Props = {
  id?: string;
  options: Option[];
  disabled?: boolean;
  errorMessage?: string;
  helperMessage?: string;
} & ComponentProps<typeof Select>;

export const CustomSelect = ({
  id,
  options,
  disabled = false,
  errorMessage = "",
  helperMessage = "",
  ...otherProps
}: Props) => {
  return (
    <>
      <Select
        id={id}
        inputId={id}
        {...otherProps}
        placeholder="Choose or search an option"
        isDisabled={disabled}
        options={options}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#0058a3",
          },
        })}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            paddingTop: "6px",
            paddingBottom: "6px",
            borderColor: "#929292",
          }),
          indicatorSeparator: (baseStyles) => ({
            ...baseStyles,
            display: "none",
          }),
          dropdownIndicator: (baseStyles) => ({
            ...baseStyles,
            ...INDICATOR_STYLE,
          }),
          clearIndicator: (baseStyles) => ({
            ...baseStyles,
            ...INDICATOR_STYLE,
          }),
        }}
      />
      {helperMessage && (
        <Text tagName="span" bodySize="s" className="mt-space25 text-[#767676]">
          {helperMessage}
        </Text>
      )}
      {errorMessage && <ErrorLabel title={errorMessage} />}
    </>
  );
};
